<template>
	<nk-wrapper v-if="context" spacing="md">
		<nk-filterbar class="lg:hidden">
			<nk-row>
				<nk-col cols="full" md="shrink" offset>
					<nk-button
						prepend-icon="filter"
						variant="outline"
						size="sm"
						expand
						@click.prevent="toggleDrawer('sidebar-veranstaltungen')"
					>
						Filter
					</nk-button>
				</nk-col>
			</nk-row>
		</nk-filterbar>
		<nk-drawer ref="sidebar" name="sidebar-veranstaltungen" title="Filter">
			<template #content>
				<template v-if="options.filterRubriken !== false">
					<nk-title size="lg">Kategorien</nk-title>
					<nk-filter-veranstaltungen-rubriken
						ref="filterVeranstaltungenRubriken"
						:apply-filter-on-change="false"
						:context="context"
						:options="options"
					/>
					<nk-divider />
				</template>
				<template v-if="options.filterZeitraum !== false">
					<nk-title size="lg">Zeitraum</nk-title>
					<nk-filter-veranstaltungen-datum
						:context="context"
						:options="options"
					/>
				</template>
			</template>
			<template #footer>
				<nk-row gutter="1">
					<nk-col cols="shrink" offset>
						<nk-button variant="solid" @click="applyFilter">
							Ergebnis Filtern
						</nk-button>
					</nk-col>
				</nk-row>
			</template>
		</nk-drawer>
		<nk-meta v-if="context.results">
			{{
				context.results > 1
					? `${context.results} Ergebnisse`
					: `${context.results} Ergebnis`
			}}
		</nk-meta>
	</nk-wrapper>
</template>

<script>
import {ref, nextTick} from 'vue';
import TemplatesDefault from '../../mixins/templates-default';
import {toggleDrawer} from '../../composables/ui';
import {jumpTo} from '#imports';

/**
 * @prop {object} context
 * @prop {boolean} options.filterZeitraum
 * @prop {boolean} options.filterRubriken
 */
export default {
	name: 'NkTemplateFilterVeranstaltungen',

	mixins: [TemplatesDefault],

	setup() {
		const filterVeranstaltungenRubriken = ref(null);

		async function applyFilter() {
			toggleDrawer('sidebar-veranstaltungen');

			// If a results container exist, jump to this section and focus it
			const resultsContainer = document.querySelector('#results');

			jumpTo(resultsContainer);

			await nextTick();

			filterVeranstaltungenRubriken.value.applyChanges();
		}

		return {toggleDrawer, applyFilter, filterVeranstaltungenRubriken};
	},
};
</script>
